import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { LicenseService } from '../../services/license.service';
import { Observable } from 'rxjs';
import { License } from '../../models/license.model';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'toast-license',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ToastComponent {
  license$: Observable<License>;
  isToastVisible: boolean = true;

  constructor(
    private licenseService: LicenseService,
    private cdr: ChangeDetectorRef
  ) {
    this.license$ = this.licenseService.getStateLicense.pipe(
      filter(
        (license: License | undefined): license is License =>
          license !== undefined
      ),
      tap((license) => {
        if (license.isLicenseValid) {
          // Convertir segundos a días (1 día = 86400 segundos)
          const remainingDays = Math.floor(license.remainingTime / 86400);
          // console.log(
          //   '(LICENSE) toast: ',
          //   license.remainingTime,
          //   'segundos -',
          //   remainingDays,
          //   'días'
          // );

          // Mostrar toast si está entre 7 y 30 días
          if (remainingDays >= 7 && remainingDays <= 30) {
            this.isToastVisible = true;
            setTimeout(() => {
              this.isToastVisible = false;
            }, 30000); // 30000ms = 30 segundos
          } else {
            this.isToastVisible = false;
          }
        } else {
          this.isToastVisible = false;
        }
      })
    );
  }

  closeToast() {
    this.isToastVisible = false;
  }
}
